module.exports = __webpack_public_path__ + "img/1.fbe0ce82.png";